import PermissionModel from '@/model/permission_model';

export default {
  install(Vue, options) {
    // console.log('Installing the Permission plugin!');
    Vue.mixin({
      methods: {
        can(permAsk) {
          permAsk = permAsk.split('|');
          if (this.$route.path == '/' || this.$route.path == '/login' || this.$route.path == '/logout') {
            return true;
          }
          let filteredPermissions = [];
          let permissions = localStorage.permissions.split(',');
          if (permissions.includes('all')) {
            filteredPermissions.push('all');
          } else if (permAsk) {
            filteredPermissions = permissions.filter(perm => permAsk.includes(perm));
          }
          //console.log(filteredPermissions);
          if (filteredPermissions && filteredPermissions.length < 1) {
            return false;
          } else {
            return true;
          }
        },
        checkPermission() {
          let res = this.permisisonRefresh();
          res.then(res => {
            permAsk = permAsk.split('|');
            if (this.$route.path == '/' || this.$route.path == '/login' || this.$route.path == '/logout') {
              return true;
            }
            let filteredPermissions = [];
            let permissions = localStorage.permissions.split(',');
            if (permissions.includes('all')) {
              filteredPermissions.push('all');
            } else if (permAsk) {
              filteredPermissions = permissions.filter(perm => permAsk.includes(perm));
            }
            //console.log(filteredPermissions);
            if (filteredPermissions && filteredPermissions.length < 1) {
              return false;
            } else {
              return true;
            }
          });
        },
        async permisisonRefresh() {
          // console.log("permisisonRefresh");
          let permList = await PermissionModel.get_my();
          // console.log(permList);
          localStorage.permissions = permList;
        },
      },
    });

    Vue.directive('can', function(el, binding, vnode) {
      bind: {
        let permAsk = binding.value.split('|');

        let filteredPermissions = [];
        let perm = localStorage.permissions.split(',');
        if (perm.includes('all')) {
          filteredPermissions.push('all');
        } else if (permAsk) {
          filteredPermissions = perm.filter(perm => permAsk.includes(perm));
        }
        //console.log(filteredPermissions);
        if (filteredPermissions.length < 1) {
          // replace HTMLElement with comment node
          const comment = document.createComment('');
          Object.defineProperty(comment, 'setAttribute', {
            value: () => undefined,
          });
          vnode.elm = comment;
          vnode.text = '';
          vnode.isComment = true;
          vnode.context = undefined;
          vnode.tag = undefined;
          vnode.data.directives = undefined;

          if (vnode.componentInstance) {
            vnode.componentInstance.$el = comment;
          }

          if (el.parentNode) {
            el.parentNode.replaceChild(comment, el);
          }
        }
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/plugins/permission.js